import { z } from 'zod';

export const searchSchema = z.object({
  ma_xp: z.string().min(1, 'Mã xã/phường là bắt buộc'),
  ten_xp: z.string().min(1, 'Tên xã/phường là bắt buộc'),
  ten_xp2: z.string().optional().nullable(),
  ma_tinh: z.string().optional().nullable().default(''),
  ma_quan: z.string().optional().nullable().default(''),
  status: z
    .union([z.string(), z.number()])
    .transform(val => Number(val))
    .default(1)
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export interface WardFormattedData {
  ma_xp: string;
  ten_xp: string;
  ten_xp2: string | null;
  ma_tinh: string | null;
  ma_quan: string | null;
  status: string | number;
  entity_model?: string;
}
